module.exports = __webpack_public_path__ + "static/media/top_shape_10_mob.975877a8.svg";